import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {templatesFeatureKey, TemplatesState} from "./templates.reducer";

export const getTemplatesState = createFeatureSelector<TemplatesState>(templatesFeatureKey);

export const getTemplates = createSelector(getTemplatesState, (state) => state.data);
export const getTemplatesLoading = createSelector(getTemplatesState, SelectorUtil.isLoading);
